import { render } from "./DeveloperItemCompliant.vue?vue&type=template&id=5ed37527"
import script from "./DeveloperItemCompliant.vue?vue&type=script&lang=js"
export * from "./DeveloperItemCompliant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__